import type { Tag } from '@carboncopyco/types';
import { mainApi } from './mainApi';

type CreateTagArgs = {
  organizationId: string;
  name: string;
};
type GetTagsArgs = { organizationId: string };
type DeleteTagArgs = { organizationId: string; id: string };
type UpdateTagArgs = {
  organizationId: string;
  id: string;
  name: string;
};

export const tagsApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    createTag: builder.mutation<Tag, CreateTagArgs>({
      query: ({ organizationId, name }) => {
        return {
          url: `/api/${organizationId}/tag`,
          method: 'POST',
          body: { name },
        };
      },
      invalidatesTags: ['Tags'],
    }),

    getTags: builder.query<Tag[], GetTagsArgs>({
      query: ({ organizationId }) => ({
        url: `/api/${organizationId}/tag`,
        method: 'GET',
      }),
      providesTags: ['Tags'],
    }),
    deleteTag: builder.mutation<null, DeleteTagArgs>({
      query: ({ organizationId, id }) => ({
        url: `/api/${organizationId}/tag/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Tags'],
    }),
    updateTag: builder.mutation<null, UpdateTagArgs>({
      query: ({ organizationId, id, name }) => ({
        url: `/api/${organizationId}/tag/${id}`,
        method: 'PUT',
        body: { name },
      }),
      invalidatesTags: ['Tags'],
    }),
  }),
});

export const {
  useCreateTagMutation,
  useGetTagsQuery,
  useDeleteTagMutation,
  useUpdateTagMutation,
  useLazyGetTagsQuery,
} = tagsApi;
